export default __webpack_public_path__ + "static/media/reaper.ffde8162.png";